import React from 'react';
import { Grid } from 'semantic-ui-react';
import { GroupTile } from './tile/groupTile';

const PopularGroupCards = () => (
  <Grid
    stretched textAlign='center' centered
    stackable padded={false}
  >
    <Grid.Column
      stretched textAlign='center'
      widescreen={5} largeScreen={5} computer={5}
      mobile={16} tablet={8}
    >
      <GroupTile />
    </Grid.Column>
    <Grid.Column
      stretched textAlign='center'
      widescreen={5} largeScreen={5} computer={5}
      mobile={16} tablet={8}
    >
      <GroupTile />
    </Grid.Column>
    <Grid.Column
      stretched textAlign='center'
      widescreen={5} largeScreen={5} computer={5}
      only='large screen'
    >
      <GroupTile />
    </Grid.Column>
  </Grid>
);

export default PopularGroupCards;



// WEBPACK FOOTER //
// ./src/components/events/components/popularGroupCards.js